import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { getLocaleStore } from '@/i18n';
import './index.less';

interface EmptyProps {
    text?: React.ReactNode;
    style?: React.CSSProperties;
}
const Empty: React.FC<EmptyProps> = ({ text = getLocaleStore().$t((v) => v.colorGroup.emptyText), style }) => {
    return (
        <div className="widget-Empty" style={style}>
            <IconFont name="EmptyDrawerBold" fontSize={48} color="var(--content-system-quaternary, #abadb2)" />
            <div className="widget-Empty-text">{text}</div>
        </div>
    );
};

export default Empty;
